import { Controller, FieldValues } from 'react-hook-form'
import { RhfProps } from './rhf.props'
import { CheckboxField, CheckboxFieldProps } from '../checkbox-field'

type CheckboxFieldRhfProps<T extends FieldValues> = CheckboxFieldProps & RhfProps<T>

export function CheckboxFieldRhf<T extends FieldValues>({
  name,
  rules = {},
  control,
  defaultValue,
  ...inputProps
}: CheckboxFieldRhfProps<T>) {
  if (inputProps.required) {
    rules.required = 'This field is required'
  }
  return (
    <Controller
      name={name}
      rules={rules}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <CheckboxField
          {...inputProps}
          value={value ?? false}
          error={!!error}
          onChange={onChange}
          helperText={error ? error.message : inputProps.helperText}
        />
      )}
    />
  )
}
